var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signal flex"},_vm._l((_vm.list),function(col,i){return _c('ul',{key:i,staticClass:"flex",class:{'flex-column': i != 1}},_vm._l((col),function(item,j){return _c('li',{key:j,staticClass:"flex-center flex-grow",class:{'z-active': _vm.index == item}},[_vm._v("指标"+_vm._s(item))])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }